import { createFileRoute } from '@tanstack/react-router';

import { AppRequestsPage } from '../features/supply/apps/AppRequestsPage';
import { appRequestsRouteSearchSchema } from '../features/supply/apps/appRequestsRouteSearch';

export const Route = createFileRoute('/supply/apps/requests')({
  validateSearch: appRequestsRouteSearchSchema,
  component: AppRequestsPage,
});
